/**
 * @generated SignedSource<<a61d8617ea192aa4b7b089449608f892>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanel_RankFieldRootRelayFragment$data = {
  readonly rankField: {
    readonly jqlTerm: string;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueViewCommonViews_ConfigurableChildIssuesPanel_RankFieldRootRelayFragment";
};
export type ui_issueViewCommonViews_ConfigurableChildIssuesPanel_RankFieldRootRelayFragment$key = {
  readonly " $data"?: ui_issueViewCommonViews_ConfigurableChildIssuesPanel_RankFieldRootRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanel_RankFieldRootRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanel_RankFieldRootRelayFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlFieldWithAliases",
      "kind": "LinkedField",
      "name": "rankField",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jqlTerm"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "b994c83cd4052c49cf64df5dab202524";

export default node;
